<template>
  <v-container fluid grid-list-md style="padding: 35px;" id="create">
    <v-flex xs12 sm12 md12 lg12>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <p class="textoUser">DASHBOARD - AIPAY</p>
        </v-col>
        <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
          <v-autocomplete outlined dense v-model="empresaSelecionada" :items="empresas" item-text="nome" item-value="id" label="Selecione a empresa" @input="carregaInformacoes(empresaSelecionada)" color="#0D47A1"></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#7B1FA2" dark style="border-radius: 10px;" flat>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Pedidos</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Dia</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 35px; padding: 12px">R$ {{valorRecargasDia}}</v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#FFA000" dark style="border-radius: 10px;" flat>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Pedidos</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Semanal</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 35px; padding: 12px">R$ {{valorRecargasSemana}}</v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#43A047" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Pedidos</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Mensal</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 35px; padding: 12px">R$ {{valorRecargasMes}}</v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#1565C0" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Total</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Pedidos mês</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 35px; padding: 12px">{{totalPedidosMes}}</v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-flex>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  baseApiUrl
} from '@/global'
import axios from 'axios'
import {
  mapState
} from 'vuex'
import moment from 'moment'
import Snackbar from '../componentes/snackbar.vue'
export default {
  components: {
    Snackbar,
    Loading
  },
  data() {
    return {
      fullPage: true,
      isLoading: false,
      empresas: [],
      valorRecargasDia: 0,
      valorRecargasMes: 0,
      totalPedidosMes: 0,
      valorRecargasSemana: 0,
      empresaSelecionada: '',
    }
  },
  computed: {
    ...mapState({
      usuarioadmin: state => state.Userpermission,
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),
  },

  mounted() {
    if (this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia)) {
      this.carregaEmpresas()
    } else {
      this.carregaInformacoes(this.companyobj.id)
    }

    this.$validator.localize('pt', this.dictionary)
  },
  
  watch: {
    //
  },

  methods: {
    async carregaEmpresas() {
      let filter

      if (this.user.tipo == 'GERENTE' && this.user.franquia) {
        filter = {
          where: {"franquia": this.user.franquia},
          order: "nome ASC",
          fields: {"nome": true, "id": true}
        }
      }
      else {
        filter = {
          order: "nome ASC",
          fields: {"nome": true, "id": true}
        }
      }

      await axios.get(baseApiUrl + 'Empresas?filter=' + JSON.stringify(filter) + '&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data.length > 0) {
          this.empresas = response.data
        }
      })
    },

    onDecode(decodedString) {
      this.codigo = decodedString
      this.usaQrcode = true
      this.confirmaCheckin()
    },

    async carregaInformacoes(empresaId) {
      this.valorRecargasDia = await this.pegaValorPedidos('DIA', empresaId)
      this.valorRecargasSemana = await this.pegaValorPedidos('SEMANA', empresaId)
      this.valorRecargasMes = await this.pegaValorPedidos('MÊS', empresaId)

      let diaInicialMes = moment().year(new Date().getFullYear()).month(new Date().getMonth()).startOf('month').format('YYYY-MM-DD')
      let diaFinalMes = moment().year(new Date().getFullYear()).month(new Date().getMonth()).endOf('month').format('YYYY-MM-DD')

      let andFilter = {
        "and": [
          {"empresaId": empresaId},
          {"created": {"gte": diaInicialMes + "T00:00:00.000Z"}},
          {"created": {"lte": diaFinalMes + "T23:59:59.999Z"}},
        ]
      }

      andFilter = JSON.stringify(andFilter)

      await axios.get(baseApiUrl + 'Pedidos/count?where=' + andFilter + '&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data) {
          this.totalPedidosMes = response.data.count
        }
      })
    },

    async pegaValorPedidos(tipo, empresaId) {
      let whereFilter = {
        'where': {
          "and": [
            {"empresaId": empresaId},
            {"statusPagamento": "PAGO"},
            {"created": {"lte": moment().format('YYYY-MM-DD') + "T23:59:59.999Z"}},
          ]
        },
        "fields": {"valor": true}
      }
      let valor = 0

      if (tipo == 'MÊS') {
        whereFilter.where.and.push(
          {"created": {"gte": moment().subtract(30, 'days').format('YYYY-MM-DD') + "T00:00:00.000Z"}},
        )
      }
      else if (tipo == 'SEMANA') {
        whereFilter.where.and.push(
          {"created": {"gte": moment().subtract(7, 'days').format('YYYY-MM-DD') + "T00:00:00.000Z"}},
        )
      }
      else if (tipo == 'DIA') {
        whereFilter.where.and.push(
          {"created": {"gte": moment().format('YYYY-MM-DD') + "T00:00:00.000Z"}}
        )
      }

      whereFilter = JSON.stringify(whereFilter)

      await axios.get(baseApiUrl + 'Pedidos?filter=' + whereFilter + '&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data) {
          response.data.forEach(pedido => {
            valor += parseFloat(pedido.valor.replace(',','.'))
          });
        }
      })

      return valor.toFixed(2).replace('.',',')
    },
  }
}
</script>

<style>
.v-data-table th {
  background-color: #90A4AE;
  font-size: 1rem;
  color: white;
}

.cardTema {
  background: #ECE9E6;
  background: -webkit-linear-gradient(to right, #FFFFFF, #ECE9E6);
  background: linear-gradient(to right, #FFFFFF, #ECE9E6);
}

.theme--light.v-table thead th {
  color: white;
}

.theme--light.v-datatable thead th.column.sortable:hover {
  color: rgb(17, 16, 16);
}

.span-pesquisa {
  width: 25%;
}

.container {
  position: relative;
  min-width: 100%;
  overflow: hidden;
}

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>
